export default __webpack_public_path__ + "static/svgBanner-e8a90761d5c5fc610503ead212d93ca8.svg";